
import { useRouter } from "vue-router";
import { inject, computed } from "vue";
export default {
  props: {
    data: {
      type: Object,
    },
    brandStoreShow: {
      type: Boolean,
      default: false
    }
  },
  setup(props: any) {
    const router = useRouter();
    const $store: any = inject("$store");
    const currencyUnit: String = $store.getSymbol();
    const item = computed(() => {
      props.data.price = props.data.promotion_price
        ? props.data.promotion_price
        : props.data.goods_price
        ? props.data.goods_price
        : props.data.price;
      props.data.price_gray = props.data.goods_marketprice
        ? props.data.goods_marketprice
        : props.data.marketprice;
      return props.data;
    });
    
   let  unifiedJump = (item:any)=>{
         $store.setDetails(item)    
         router.push({
          name:'goods',
          params:{
              id:item.goods_id
          }
     })
   }

    return {
      currencyUnit,
      item,
      unifiedJump,
    };
  },
};
